import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import * as i3$1 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i4 from '@niceltd/sol/autocomplete';
import { AutoCompleteModule } from '@niceltd/sol/autocomplete';
import * as i2$1 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i2 from '@niceltd/sol/checkbox';
import { CheckboxModule } from '@niceltd/sol/checkbox';
import * as i3 from '@niceltd/sol/icon';
import { IconModule } from '@niceltd/sol/icon';
import * as i5 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import { TextInputModule } from '@niceltd/sol/text-input';
function OptionComponent_Conditional_1_sol_checkbox_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-checkbox", 6);
    i0.ɵɵlistener("checkedChange", function OptionComponent_Conditional_1_sol_checkbox_1_Template_sol_checkbox_checkedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r6.onCheckboxChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("checked", ctx_r5.selected)("indeterminate", ctx_r5.indeterminate)("disabled", true)("ariaLabel", ctx_r5.ariaLabel)("tabindex", -1);
  }
}
function OptionComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtemplate(1, OptionComponent_Conditional_1_sol_checkbox_1_Template, 1, 5, "sol-checkbox", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isReadOnly);
  }
}
function OptionComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "sol-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", ctx_r1.icon);
  }
}
function OptionComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
    i0.ɵɵpipe(1, "solTextHighlighter");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.displayText, ctx_r2.searchText), i0.ɵɵsanitizeHtml);
  }
}
function OptionComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c0 = a0 => ({
  optionScope: a0
});
function OptionComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, OptionComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.projectedContent)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r3));
  }
}
function OptionComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const _c1 = ["*"];
const _forTrack0 = ($index, $item) => $item.value;
function SelectComponent_Conditional_1_sol_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 14);
    i0.ɵɵlistener("onClick", function SelectComponent_Conditional_1_sol_button_7_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.clearSearch());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(9);
    i0.ɵɵproperty("iconPositionedFront", _r7)("variant", "text")("size", "medium");
  }
}
function SelectComponent_Conditional_1_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
  }
}
function SelectComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 8);
    i0.ɵɵelement(3, "path", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "input", 10);
    i0.ɵɵlistener("input", function SelectComponent_Conditional_1_Template_input_input_4_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.onSearchInputChange($event));
    });
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 11);
    i0.ɵɵtemplate(7, SelectComponent_Conditional_1_sol_button_7_Template, 1, 3, "sol-button", 12)(8, SelectComponent_Conditional_1_ng_template_8_Template, 1, 0, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 4, "searchHere"));
    i0.ɵɵproperty("value", ctx_r0.searchText)("tabindex", 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.searchText.length);
  }
}
function SelectComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "noResult"));
  }
}
function SelectComponent_div_3_sol_option_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "queryAllSelectOption"));
  }
}
function SelectComponent_div_3_sol_option_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "queryAllResultsSelectOption"));
  }
}
function SelectComponent_div_3_sol_option_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-option", 20);
    i0.ɵɵlistener("optionSelectedChanged", function SelectComponent_div_3_sol_option_2_Template_sol_option_optionSelectedChanged_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r15 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r15.toggleSelectAll());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, SelectComponent_div_3_sol_option_2_span_2_Template, 3, 3, "span", 21)(3, SelectComponent_div_3_sol_option_2_span_3_Template, 3, 3, "span", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(1, 7, "selectAll"));
    i0.ɵɵproperty("tabindex", 0)("selected", ctx_r12.selectAllChecked)("showCheckbox", ctx_r12.isMultiple)("indeterminate", ctx_r12.isIndeterminate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r12.searchText.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r12.searchText.length);
  }
}
function SelectComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, SelectComponent_div_3_sol_option_2_Template, 4, 9, "sol-option", 18);
    i0.ɵɵelement(3, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "selectAll"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isMultiple && ctx_r2.displayOptions.length);
  }
}
function SelectComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "div", 24);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25)(6, "sol-button", 26);
    i0.ɵɵlistener("onClick", function SelectComponent_div_4_Template_sol_button_onClick_6_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.onClearAll());
    });
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 5, "selectUpToXItems", ctx_r3.maxSelectionLimit));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("size", "small")("variant", "basic")("disabled", !(ctx_r3.selectAllChecked || ctx_r3.isIndeterminate));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "clear"));
  }
}
function SelectComponent_For_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "sol-option", 28);
    i0.ɵɵlistener("optionSelectedChanged", function SelectComponent_For_7_ng_container_0_Template_sol_option_optionSelectedChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r27 = i0.ɵɵnextContext();
      const item_r19 = ctx_r27.$implicit;
      const i_r20 = ctx_r27.$index;
      const ctx_r26 = i0.ɵɵnextContext();
      ctx_r26.onOptionSelectionChange($event, item_r19);
      return i0.ɵɵresetView(ctx_r26.focusIndex = i_r20);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    const item_r19 = ctx_r29.$implicit;
    const i_r20 = ctx_r29.$index;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", item_r19.id)("tabindex", i_r20 === ctx_r24.focusIndex ? 0 : -1)("index", i_r20)("icon", item_r19.icon)("ariaLabel", item_r19.displayText)("displayText", item_r19.displayText)("disabled", item_r19.disabledOption)("selected", item_r19.selected)("searchText", ctx_r24.searchText)("showCheckbox", ctx_r24.isMultiple)("isReadOnly", ctx_r24.isReadOnly)("projectedContent", item_r19.customTmpl ? ctx_r24.projectedContent : undefined)("projectedData", item_r19.projectedData);
  }
}
function SelectComponent_For_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r19.name);
  }
}
function SelectComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SelectComponent_For_7_ng_container_0_Template, 2, 13, "ng-container", 21)(1, SelectComponent_For_7_div_1_Template, 3, 1, "div", 27);
  }
  if (rf & 2) {
    const item_r19 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", !item_r19.isCategory);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r19.isCategory);
  }
}
class OptionComponent {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.tabindex = 0;
    this.selected = false;
    this.indeterminate = false;
    this.disabled = false;
    this.showCheckbox = false;
    this.isReadOnly = false;
    this.optionClicked = new EventEmitter();
    this.optionSelectedChanged = new EventEmitter();
    this.optionKeydown = new EventEmitter();
  }
  onOptionClick() {
    if (!this.disabled) {
      this.toggleSelection();
      this.optionSelectedChanged.emit(this.selected);
      this.optionClicked.emit();
    }
  }
  onCheckboxChange(event) {
    this.selected = event.checked;
    this.optionSelectedChanged.emit(this.selected);
  }
  onOptionKeydown(event) {
    if (!this.disabled) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleSelection();
        this.optionSelectedChanged.emit(this.selected);
        this.optionClicked.emit();
      }
      this.optionKeydown.emit(event);
    }
  }
  toggleSelection() {
    if (this.showCheckbox) {
      this.selected = !this.selected;
    } else {
      this.selected = true;
    }
  }
  static {
    this.ɵfac = function OptionComponent_Factory(t) {
      return new (t || OptionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OptionComponent,
      selectors: [["sol-option"]],
      inputs: {
        id: "id",
        icon: "icon",
        index: "index",
        tabindex: "tabindex",
        displayText: "displayText",
        ariaLabel: "ariaLabel",
        selected: "selected",
        indeterminate: "indeterminate",
        disabled: "disabled",
        showCheckbox: "showCheckbox",
        isReadOnly: "isReadOnly",
        projectedContent: "projectedContent",
        projectedData: "projectedData",
        searchText: "searchText",
        optionTemplate: "optionTemplate"
      },
      outputs: {
        optionClicked: "optionClicked",
        optionSelectedChanged: "optionSelectedChanged",
        optionKeydown: "optionKeydown"
      },
      ngContentSelectors: _c1,
      decls: 6,
      vars: 13,
      consts: [[1, "sol-option", 3, "id", "tabindex", "click", "keydown"], ["class", "sol-option-checkbox"], ["class", "sol-option-icon"], ["class", "sol-option-text", 3, "innerHtml"], [1, "sol-option-checkbox"], [3, "checked", "indeterminate", "disabled", "ariaLabel", "tabindex", "checkedChange", 4, "ngIf"], [3, "checked", "indeterminate", "disabled", "ariaLabel", "tabindex", "checkedChange"], [1, "sol-option-icon"], [3, "icon"], [1, "sol-option-text", 3, "innerHtml"], [1, "sol-option-text"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function OptionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("click", function OptionComponent_Template_div_click_0_listener() {
            return ctx.onOptionClick();
          })("keydown", function OptionComponent_Template_div_keydown_0_listener($event) {
            return ctx.onOptionKeydown($event);
          });
          i0.ɵɵtemplate(1, OptionComponent_Conditional_1_Template, 2, 1, "span", 1)(2, OptionComponent_Conditional_2_Template, 2, 1, "div", 2)(3, OptionComponent_Conditional_3_Template, 2, 4, "span", 3)(4, OptionComponent_Conditional_4_Template, 2, 4)(5, OptionComponent_Conditional_5_Template, 2, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("read-only", ctx.isReadOnly)("option-selected", !ctx.isReadOnly ? ctx.selected : "")("option-disabled", ctx.disabled);
          i0.ɵɵproperty("id", ctx.id ? "sol-option-" + ctx.id : null)("tabindex", ctx.tabindex);
          i0.ɵɵattribute("data-index", ctx.index)("aria-disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵconditional(1, ctx.showCheckbox && !ctx.isReadOnly ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(2, ctx.icon ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(3, ctx.displayText && !ctx.projectedContent ? 3 : ctx.projectedContent ? 4 : 5);
        }
      },
      dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.CheckboxComponent, i3.IconComponent, i4.TextHighlighterPipe],
      styles: [".highlighter{font-weight:var(--typography-opensans-body-body5-font-weight);color:#000}.sol-option{border:.0625rem solid transparent;display:inline-flex;justify-content:flex-start;padding:.5rem .625rem;margin:0;align-items:stretch;gap:.5rem;width:100%;height:2.25rem;background:#fff;cursor:pointer;position:relative;color:var(--interface-text-700, #333);box-sizing:border-box}.sol-option:not(.option-disabled) .sol-checkbox input.sol-checkbox-inputbox:indeterminate:disabled,.sol-option:not(.option-disabled) .sol-checkbox input.sol-checkbox-inputbox:checked:disabled{background:var(--color-interface-blue450);border-color:var(--color-interface-blue450)}.sol-option.option-selected{background:var(--color-background-navigation-selected, rgba(174, 211, 240, .3019607843))}.sol-option.option-disabled{cursor:none;pointer-events:none;background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-option:focus-visible{border-color:var(--color-globalstate-focus);outline:none}.sol-option:focus-visible:not(:disabled),.sol-option:hover:not(:disabled){background:var(--color-globalstate-hover-background)}.sol-option .sol-checkbox{min-height:1rem}.sol-option .sol-option-icon{display:inline-flex}.sol-option .sol-option-text{cursor:pointer;font-family:var(--typography-opensans-body-body3-font-family);font-size:.8125rem;font-style:normal;font-weight:400;line-height:.975rem;width:100%;align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.read-only:hover:not(:disabled){background:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OptionComponent, [{
    type: Component,
    args: [{
      selector: 'sol-option',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div\n  [attr.data-index]=\"index\"\n  class=\"sol-option\"\n  [id]=\"id ? 'sol-option-' + id : null\"\n  [class.read-only]=\"isReadOnly\"\n  [class.option-selected]=\"!isReadOnly ? selected : ''\"\n  [class.option-disabled]=\"disabled\"\n  [attr.aria-disabled]=\"disabled\"\n  [tabindex]=\"tabindex\"\n  (click)=\"onOptionClick()\"\n  (keydown)=\"onOptionKeydown($event)\"\n>\n  @if (showCheckbox && !isReadOnly) {\n    <span class=\"sol-option-checkbox\">\n      <sol-checkbox\n        *ngIf=\"!isReadOnly\"\n        [checked]=\"selected\"\n        [indeterminate]=\"indeterminate\"\n        [disabled]=\"true\"\n        [ariaLabel]=\"ariaLabel\"\n        [tabindex]=\"-1\"\n        (checkedChange)=\"onCheckboxChange($event)\"\n      >\n      </sol-checkbox>\n    </span>\n  }\n  @if (icon) {\n    <div class=\"sol-option-icon\"><sol-icon [icon]=\"icon\"></sol-icon></div>\n  }\n  @if (displayText && !projectedContent) {\n    <span class=\"sol-option-text\" [innerHtml]=\"displayText | solTextHighlighter: searchText\"></span>\n  } @else if (projectedContent) {\n    <span class=\"sol-option-text\">\n      <!--Note: Need suggestions -->\n      <ng-container *ngTemplateOutlet=\"projectedContent; context: { optionScope: this }\"></ng-container>\n    </span>\n  } @else {\n    <span class=\"sol-option-text\">\n      <ng-content></ng-content>\n    </span>\n  }\n</div>\n",
      styles: [".highlighter{font-weight:var(--typography-opensans-body-body5-font-weight);color:#000}.sol-option{border:.0625rem solid transparent;display:inline-flex;justify-content:flex-start;padding:.5rem .625rem;margin:0;align-items:stretch;gap:.5rem;width:100%;height:2.25rem;background:#fff;cursor:pointer;position:relative;color:var(--interface-text-700, #333);box-sizing:border-box}.sol-option:not(.option-disabled) .sol-checkbox input.sol-checkbox-inputbox:indeterminate:disabled,.sol-option:not(.option-disabled) .sol-checkbox input.sol-checkbox-inputbox:checked:disabled{background:var(--color-interface-blue450);border-color:var(--color-interface-blue450)}.sol-option.option-selected{background:var(--color-background-navigation-selected, rgba(174, 211, 240, .3019607843))}.sol-option.option-disabled{cursor:none;pointer-events:none;background-color:var(--color-globalstate-disabled-background);color:var(--color-globalstate-disabled-content)}.sol-option:focus-visible{border-color:var(--color-globalstate-focus);outline:none}.sol-option:focus-visible:not(:disabled),.sol-option:hover:not(:disabled){background:var(--color-globalstate-hover-background)}.sol-option .sol-checkbox{min-height:1rem}.sol-option .sol-option-icon{display:inline-flex}.sol-option .sol-option-text{cursor:pointer;font-family:var(--typography-opensans-body-body3-font-family);font-size:.8125rem;font-style:normal;font-weight:400;line-height:.975rem;width:100%;align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.read-only:hover:not(:disabled){background:none}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    id: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    index: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    displayText: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    indeterminate: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    showCheckbox: [{
      type: Input
    }],
    isReadOnly: [{
      type: Input
    }],
    projectedContent: [{
      type: Input
    }],
    projectedData: [{
      type: Input
    }],
    searchText: [{
      type: Input
    }],
    optionTemplate: [{
      type: Input
    }],
    optionClicked: [{
      type: Output
    }],
    optionSelectedChanged: [{
      type: Output
    }],
    optionKeydown: [{
      type: Output
    }]
  });
})();
class SelectComponent {
  get maxSelectionLimit() {
    return this._maxSelectionLimit;
  }
  set maxSelectionLimit(value) {
    // Ensure default value is 0 if undefined or null
    this._maxSelectionLimit = value || 1;
    if (value < 1) {
      console.error('Minimum selection limit should be 2. Setting to default value 1');
      this._maxSelectionLimit = 1;
    } else if (value > 250) {
      console.error('Maximum selection limit should be 250');
      this._maxSelectionLimit = 250;
    }
  }
  set options(value) {
    if (value && value.length > 250) {
      console.error('Maximum 250 elements');
      this._options = value.slice(0, 250);
    } else {
      this._options = value || [];
    }
  }
  get options() {
    return this._options;
  }
  constructor(cdr, elementRef, renderer) {
    this.cdr = cdr;
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.focusIndex = 0;
    this.searchText = '';
    // Array of all options with updated selected properties
    this._allOptions = [];
    // Array of options to be displayed with selected properties
    this.displayOptions = [];
    this._options = [];
    //stores selection as array
    this._selectionArray = [];
    this._maxSelectionLimit = 1;
    this.searchEnabled = false;
    this.isMultiple = false;
    this.optionsLabel = 'name';
    this.optionsValue = 'value';
    this.optionsIcon = 'icon';
    this.isReadOnly = false;
    this.selectAllChecked = false;
    this.selectionChange = new EventEmitter();
    this.searchChanged = new EventEmitter();
  }
  ngOnInit() {
    this.updateSelectionArray();
  }
  updateSelectionArray() {
    if (this.selection) {
      if (!this.isMultiple) {
        this._selectionArray[0] = this.selection;
      } else {
        this._selectionArray = [...this.selection];
      }
    }
  }
  ngAfterViewInit() {
    this.updateAllOptions();
    this.sortAllOptions();
    this.updateDisplayOptions();
    this.updateOptionsDisabledState();
    this.UpdateCategoriesBased();
    this.updateIndexProperties();
    const focusTrapAnchors = this.elementRef.nativeElement.querySelectorAll('.cdk-focus-trap-anchor');
    focusTrapAnchors.forEach(anchor => {
      this.renderer.setAttribute(anchor, 'tabindex', '-1');
    });
    this.cdr.detectChanges();
  }
  updateIndexProperties() {
    this.focusIndex = this.displayOptions.findIndex(el => !el.disabledOption);
    this.hasEnabledOption = this.focusIndex > -1;
  }
  getDisplayOptions() {
    return this.displayOptions;
  }
  /**
   * updates `displayOptions` using `_allOptions` and `searchText`
   * @returns array of options to be displayed
   */
  updateDisplayOptions() {
    if (this.searchText) {
      if (this.searchFunction) {
        this.displayOptions = this._allOptions.filter(opt => this.searchFunction(opt.option, this.searchText));
      } else {
        this.displayOptions = this._allOptions.filter(opt => opt.displayText.toLowerCase().includes(this.searchText.toLowerCase()));
      }
      this.displayOptions = this.isReadOnly ? this.displayOptions.filter(opt => opt.selected) : this.displayOptions;
    } else {
      this.displayOptions = this.isReadOnly ? this._allOptions.filter(opt => opt.selected) : [...this._allOptions];
    }
    this.selectAllChecked = this.isAllSelected();
    return this.displayOptions;
  }
  /**
   * updates `displayOptions` after search change
   * @emits `searchChanged` event
   */
  onSearchInputChange(event) {
    const text = event.target.value;
    this.onSearchTextChange(text);
  }
  onSearchTextChange(text) {
    if (this.searchText === text) {
      return;
    }
    this.searchText = text;
    this.sortAllOptions();
    this.updateDisplayOptions();
    this.updateOptionsDisabledState();
    this.updateIndexProperties();
    this.UpdateCategoriesBased();
    this.selectAllChecked = this.isAllSelected();
    this.searchChanged.emit(text);
  }
  /**
   * updates `_allOptions` using `options` and `_selectionArray`
   */
  updateAllOptions() {
    this._allOptions = this.options.map(option => ({
      id: option[this.optionsValue],
      displayText: option[this.optionsLabel],
      disabled: option.disabled,
      customTmpl: option.customTmpl,
      projectedData: option.projectedData,
      selected: this._selectionArray.includes(option[this.optionsValue]),
      option: option,
      icon: option[this.optionsIcon],
      category: option.category,
      disabledOption: option.disabled
    }));
    this.selectAllChecked = this.isAllSelected();
  }
  sortAllOptions() {
    this._allOptions.sort((a, b) => {
      if (a.selected === b.selected) {
        return 0;
      }
      return a.selected ? -1 : 1;
    });
  }
  isAllSelected() {
    const filteredArray = this.displayOptions.filter(items => !items.disabled);
    return filteredArray.every(option => option.selected) && filteredArray.length > 0;
  }
  get isIndeterminate() {
    return this.selectAllChecked ? false : this.displayOptions.some(option => option.selected && !option.disabled);
  }
  toggleSelectAll() {
    this.selectAllChecked = !this.selectAllChecked;
    this._allOptions.forEach(option => {
      if (!option.disabled) {
        option.selected = this.selectAllChecked;
      }
    });
    const selectedArray = this.displayOptions.filter(option => !option.disabled && option.id);
    if (this.selectAllChecked) {
      selectedArray.forEach(item => {
        if (!this._selectionArray.includes(item.id)) this._selectionArray.push(item.id);
      });
    } else {
      this._selectionArray = this._selectionArray.filter(id => !selectedArray.find(item => item.id === id));
    }
    this.selectionChange.emit(this._selectionArray);
    this.updateAllOptions();
    this.updateDisplayOptions();
    this.UpdateCategoriesBased();
  }
  onOptionSelectionChange(isOptionSelected, currentOption) {
    if (this.isMultiple) {
      if (isOptionSelected) {
        if (!this._selectionArray.includes(currentOption.id)) {
          this._selectionArray.push(currentOption.id);
        }
      } else {
        const indexToRemove = this._selectionArray.findIndex(val => val === currentOption.id);
        this._selectionArray.splice(indexToRemove, 1);
      }
      // updating display options and not triggering change detection
      const index = this.displayOptions.findIndex(res => res.id === currentOption.id);
      this.displayOptions[index].selected = isOptionSelected;
      this.selectAllChecked = this.isAllSelected();
      this.selectionChange.emit(this._selectionArray);
    } else {
      if (this._selectionArray) {
        this._selectionArray[0] = currentOption.id;
      }
      this.selectionChange.emit(this._selectionArray[0]);
    }
    this.updateAllOptions();
    this.updateOptionsDisabledState();
  }
  updateOptionsDisabledState() {
    if (this.maxSelectionLimit <= 1) return;
    const shouldDisableOptions = this.maxSelectionLimit <= this._selectionArray.length;
    this.displayOptions.forEach(option => {
      if (shouldDisableOptions && (!option.selected || option.disabled)) {
        option.disabledOption = true;
      } else {
        option.disabledOption = option.disabled;
      }
    });
  }
  onClearAll() {
    this.selectAllChecked = true;
    this.toggleSelectAll();
    this.updateIndexProperties();
    this.focusByIndex(this.focusIndex, 0);
  }
  /**
   * updates `displayOptions` based on categories
   */
  UpdateCategoriesBased() {
    // Items without categories are displayed first, followed by items with categories
    const itemsWithoutCategory = this.displayOptions.filter(item => !item.category || item.selected);
    const itemsWithCategory = this.displayOptions.filter(item => item.category && !item.selected);
    // Grouping items by categories
    const groupedByCategory = itemsWithCategory.reduce((groups, item) => {
      const category = item.category;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(item);
      return groups;
    }, {});
    this.displayOptions = [...itemsWithoutCategory];
    // Building the final list of options to be displayed
    for (const [category, items] of Object.entries(groupedByCategory)) {
      this.displayOptions.push({
        isCategory: true,
        name: category,
        disabledOption: true
      });
      this.displayOptions.push(...items);
    }
  }
  clearSearch() {
    this.onSearchTextChange('');
    this.elementRef.nativeElement.querySelector('.search-input-box').focus();
  }
  focusByIndex(index, direction) {
    this.focusIndex = index;
    const element = this.elementRef.nativeElement;
    let target = element.querySelector(`[data-index="${index}"]`);
    if (!target) {
      target = element.querySelector(`[data-index="${index + direction}"]`);
      this.focusIndex = index + direction;
    }
    target.focus();
  }
  moveFocus(direction, $event) {
    if ($event) {
      $event.preventDefault();
    }
    let newFocusIndex = this.focusIndex + direction;
    if (newFocusIndex >= this.displayOptions.length) {
      // on last option arrow down
      // setting focus to top element
      newFocusIndex = 0;
    } else if (newFocusIndex < 0) {
      // on top element arrow up
      // setting focus to bottom element
      newFocusIndex = this.displayOptions.length - 1;
    }
    // check if it is option to check disabled property
    if (this.displayOptions[newFocusIndex]) {
      const isdisabled = this.displayOptions[newFocusIndex].disabledOption;
      if (isdisabled && this.hasEnabledOption) {
        // to avoid infinite loop, it has to have atleast one option enabled
        this.focusIndex = newFocusIndex;
        this.moveFocus(direction);
        return;
      }
    }
    this.focusByIndex(newFocusIndex, direction);
  }
  static {
    this.ɵfac = function SelectComponent_Factory(t) {
      return new (t || SelectComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectComponent,
      selectors: [["sol-select"]],
      inputs: {
        maxSelectionLimit: "maxSelectionLimit",
        searchEnabled: "searchEnabled",
        searchFunction: "searchFunction",
        isMultiple: "isMultiple",
        optionsLabel: "optionsLabel",
        optionsValue: "optionsValue",
        optionsIcon: "optionsIcon",
        isReadOnly: "isReadOnly",
        projectedContent: "projectedContent",
        options: "options",
        selection: "selection"
      },
      outputs: {
        selectionChange: "selectionChange",
        searchChanged: "searchChanged"
      },
      decls: 8,
      vars: 4,
      consts: [["cdkTrapFocus", "", "cdkTrapFocusAutoCapture", "", 1, "sol-select"], ["class", "search-inner"], ["class", "no-results-container", 4, "ngIf"], ["class", "select-all-checkbox-container", "role", "listbox", 4, "ngIf"], ["class", "max-selection-limit-container", 4, "ngIf"], ["role", "listbox", "aria-label", "list options", 1, "sol-options-list", 3, "keydown.arrowdown", "keydown.arrowup"], [1, "search-inner"], [1, "search-icon-container"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z", "fill", "#3F5C69"], ["type", "text", "autocomplete", "off", "name", "search", "id", "search-id", 1, "search-input-box", 3, "placeholder", "value", "tabindex", "input"], [1, "search-clear-btn"], [3, "iconPositionedFront", "variant", "size", "onClick", 4, "ngIf"], ["LeadingIcon", ""], [3, "iconPositionedFront", "variant", "size", "onClick"], [1, "clear-search-icon"], [1, "no-results-container"], ["role", "listbox", 1, "select-all-checkbox-container"], ["role", "option", 3, "tabindex", "selected", "ariaLabel", "showCheckbox", "indeterminate", "optionSelectedChanged", 4, "ngIf"], [1, "divider"], ["role", "option", 3, "tabindex", "selected", "ariaLabel", "showCheckbox", "indeterminate", "optionSelectedChanged"], [4, "ngIf"], [1, "max-selection-limit-container"], [1, "max-selection-limit-row"], [1, "max-selection-limit-text"], [1, "max-selection-limit-clear-button"], [3, "size", "variant", "disabled", "onClick"], ["class", "dropdown-category", 4, "ngIf"], ["role", "option", 3, "id", "tabindex", "index", "icon", "ariaLabel", "displayText", "disabled", "selected", "searchText", "showCheckbox", "isReadOnly", "projectedContent", "projectedData", "optionSelectedChanged"], [1, "dropdown-category"]],
      template: function SelectComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, SelectComponent_Conditional_1_Template, 10, 6, "div", 1)(2, SelectComponent_div_2_Template, 3, 3, "div", 2)(3, SelectComponent_div_3_Template, 4, 4, "div", 3)(4, SelectComponent_div_4_Template, 10, 10, "div", 4);
          i0.ɵɵelementStart(5, "ul", 5);
          i0.ɵɵlistener("keydown.arrowdown", function SelectComponent_Template_ul_keydown_arrowdown_5_listener($event) {
            return ctx.moveFocus(1, $event);
          })("keydown.arrowup", function SelectComponent_Template_ul_keydown_arrowup_5_listener($event) {
            return ctx.moveFocus(-1, $event);
          });
          i0.ɵɵrepeaterCreate(6, SelectComponent_For_7_Template, 2, 2, null, null, _forTrack0);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(1, ctx.isReadOnly && (ctx.displayOptions.length >= 10 || ctx.searchText) || ctx.searchEnabled && !ctx.isReadOnly ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.displayOptions.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isReadOnly && ctx.isMultiple && ctx.displayOptions.length && ctx.maxSelectionLimit < 2);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isMultiple && ctx.displayOptions.length && ctx.maxSelectionLimit >= 2);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.displayOptions);
        }
      },
      dependencies: [i1.NgIf, i2$1.ButtonComponent, i3$1.CdkTrapFocus, OptionComponent, i5.TranslationPipe],
      styles: [".sol-select{box-sizing:border-box;width:100%;position:relative;border-radius:var(--radii-small-allcorners);border:1px solid var(--color-globalstate-active-border);background:#fff;box-shadow:0 1px 2px #00000052;font-family:var(--typography-opensans-body-body1-font-family);font-size:var(--typography-opensans-body1-font-size);overflow-x:auto}.sol-select .cdk-overlay-pane{width:100%}.sol-select .dropdown-category{padding:.5rem .625rem;font-size:.8125rem;font-weight:700}.sol-select .search-inner{display:flex;flex-direction:row;height:2.25rem;align-items:center;gap:.5rem;padding:0 .25rem 0 .625rem}.sol-select .search-inner .search-icon-container{display:flex;flex-direction:column;justify-content:center;height:1.25rem;width:1.25rem}.sol-select .search-inner .search-input-box{flex-grow:1;height:1.125rem;appearance:none;border:none;outline:none;padding:0}.sol-select .search-inner .search-input-box::placeholder{color:var(--color-globalstate-inactive-icon);font-size:.8125rem}.sol-select .search-inner .search-clear-btn{height:1.75rem;width:1.75rem}.sol-select .no-results-container{height:1.25rem;margin:0;padding:.5rem .625rem;font-family:var(--typography-opensans-body-body3-font-family);font-size:.8125rem;font-style:normal;font-weight:400;line-height:.975rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-select .select-all-checkbox-container{height:2.65rem;display:flex;flex-direction:column;justify-content:flex-start;background:var(--interface-background-50, #f5f8fa)}.sol-select .select-all-checkbox-container .sol-option{background:var(--interface-background-50, #f5f8fa)}.sol-select .select-all-checkbox-container:hover,.sol-select .select-all-checkbox-container:hover .sol-option{background:var(--color-globalstate-hover-background)}.sol-select .select-all-checkbox-container .divider{border-width:0 0 .0625rem;border-style:solid;border-color:#ebebeb;margin:0 .25rem}.sol-select .max-selection-limit-container{box-sizing:border-box;border:1px solid var(--color-interface-border2);border-left-width:0;border-right-width:0;height:2.25rem;display:flex;flex-direction:column;justify-content:center;padding:0 .625rem;background-color:var(--color-surface-secondary)}.sol-select .max-selection-limit-container .max-selection-limit-row{display:flex;flex-direction:row;justify-content:space-between}.sol-select .max-selection-limit-container .max-selection-limit-row .max-selection-limit-text{text-transform:var(--typography-opensans-body-body3-text-case);text-indent:var(--typography-opensans-body-body3-paragraph-indent);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);font-stretch:var(--typography-opensans-body-body3-font-stretch);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-family:var(--typography-opensans-body-body3-font-family);text-decoration:var(--typography-opensans-body-body3-text-decoration);font-size:var(--typography-opensans-body-body3-font-size);width:100%;align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-select .max-selection-limit-container .max-selection-limit-row .max-selection-limit-clear-button{align-self:center}.sol-select .max-selection-limit-container .max-selection-limit-row button div{min-width:4rem}.sol-select .clear-search-icon{height:1.75rem;width:1.75rem;background:url('data:image/svg+xml,<svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A    <path%0A        d=\"M11.0938 10.3245L14.7656 6.68112C15.0781 6.37104 15.0781 5.90592 14.7656 5.59584C14.4531 5.28577 13.9844 5.28577 13.6719 5.59584L10 9.23926L6.32812 5.51832C6.01562 5.20825 5.54688 5.20825 5.23438 5.51832C4.92188 5.8284 4.92188 6.29352 5.23438 6.6036L8.90625 10.3245L5.23438 13.9679C4.92188 14.278 4.92188 14.7431 5.23438 15.0532C5.54688 15.3633 6.01562 15.3633 6.32812 15.0532L10 11.4098L13.6719 15.0532C13.9844 15.3633 14.4531 15.3633 14.7656 15.0532C15.0781 14.7431 15.0781 14.278 14.7656 13.9679L11.0938 10.3245Z\"%0A        fill=\"%233F5C69\" />%0A</svg>%0A');background-position:center;background-repeat:no-repeat;background-size:inherit;border:0}.sol-select .sol-options-list{list-style-type:none;min-width:15rem;max-height:13.5rem;overflow:auto;margin:0;padding:0}.sol-select *{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}.sol-select *::-webkit-scrollbar{width:8px}.sol-select *::-webkit-scrollbar-corner{display:none}.sol-select *::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}.sol-select *::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}.sol-select *::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}.sol-select * ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectComponent, [{
    type: Component,
    args: [{
      selector: 'sol-select',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"sol-select\" cdkTrapFocus cdkTrapFocusAutoCapture>\n  @if ((isReadOnly && (displayOptions.length >= 10 || searchText)) || (searchEnabled && !isReadOnly)) {\n    <div class=\"search-inner\">\n      <div class=\"search-icon-container\">\n        <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path\n            d=\"M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z\"\n            fill=\"#3F5C69\"\n          />\n        </svg>\n      </div>\n      <input\n        class=\"search-input-box\"\n        type=\"text\"\n        placeholder=\"{{ 'searchHere' | translate }}\"\n        autocomplete=\"off\"\n        [value]=\"searchText\"\n        (input)=\"onSearchInputChange($event)\"\n        name=\"search\"\n        id=\"search-id\"\n        [tabindex]=\"0\"\n      />\n      <div class=\"search-clear-btn\">\n        <sol-button *ngIf=\"searchText.length\" [iconPositionedFront]=\"LeadingIcon\" [variant]=\"'text'\" [size]=\"'medium'\" (onClick)=\"clearSearch()\">\n        </sol-button>\n        <ng-template #LeadingIcon>\n          <div class=\"clear-search-icon\"></div>\n        </ng-template>\n      </div>\n    </div>\n  }\n  <div class=\"no-results-container\" *ngIf=\"!displayOptions.length\">{{ 'noResult' | translate }}</div>\n  <div\n    class=\"select-all-checkbox-container\"\n    role=\"listbox\"\n    [attr.aria-label]=\"'selectAll' | translate\"\n    *ngIf=\"!isReadOnly && isMultiple && displayOptions.length && maxSelectionLimit < 2\"\n  >\n    <sol-option\n      role=\"option\"\n      *ngIf=\"isMultiple && displayOptions.length\"\n      [tabindex]=\"0\"\n      [selected]=\"selectAllChecked\"\n      ariaLabel=\"{{ 'selectAll' | translate }}\"\n      (optionSelectedChanged)=\"toggleSelectAll()\"\n      [showCheckbox]=\"isMultiple\"\n      [indeterminate]=\"isIndeterminate\"\n    >\n      <span *ngIf=\"!searchText.length\">{{ 'queryAllSelectOption' | translate }}</span>\n      <span *ngIf=\"searchText.length\">{{ 'queryAllResultsSelectOption' | translate }}</span>\n    </sol-option>\n    <div class=\"divider\"></div>\n  </div>\n  <div class=\"max-selection-limit-container\" *ngIf=\"isMultiple && displayOptions.length && maxSelectionLimit >= 2\">\n    <div class=\"max-selection-limit-row\">\n      <div class=\"max-selection-limit-text\">{{ 'selectUpToXItems' | translate: maxSelectionLimit }}</div>\n      <div class=\"max-selection-limit-clear-button\">\n        <sol-button [size]=\"'small'\" [variant]=\"'basic'\" [disabled]=\"!(selectAllChecked || isIndeterminate)\" (onClick)=\"onClearAll()\"\n          ><div>{{ 'clear' | translate }}</div></sol-button\n        >\n      </div>\n    </div>\n  </div>\n\n  <ul\n    role=\"listbox\"\n    class=\"sol-options-list\"\n    aria-label=\"list options\"\n    (keydown.arrowdown)=\"moveFocus(1, $event)\"\n    (keydown.arrowup)=\"moveFocus(-1, $event)\"\n  >\n    @for (item of displayOptions; track item.value; let i = $index) {\n      <ng-container *ngIf=\"!item.isCategory\">\n        <sol-option\n          role=\"option\"\n          [id]=\"item.id\"\n          [tabindex]=\"i === focusIndex ? 0 : -1\"\n          [index]=\"i\"\n          [icon]=\"item.icon\"\n          [ariaLabel]=\"item.displayText\"\n          [displayText]=\"item.displayText\"\n          [disabled]=\"item.disabledOption\"\n          [selected]=\"item.selected\"\n          [searchText]=\"searchText\"\n          (optionSelectedChanged)=\"onOptionSelectionChange($event, item); focusIndex = i\"\n          [showCheckbox]=\"isMultiple\"\n          [isReadOnly]=\"isReadOnly\"\n          [projectedContent]=\"item.customTmpl ? projectedContent : undefined\"\n          [projectedData]=\"item.projectedData\"\n        ></sol-option>\n      </ng-container>\n      <div class=\"dropdown-category\" *ngIf=\"item.isCategory\">\n        <span>{{ item.name }}</span>\n      </div>\n    }\n  </ul>\n</div>\n",
      styles: [".sol-select{box-sizing:border-box;width:100%;position:relative;border-radius:var(--radii-small-allcorners);border:1px solid var(--color-globalstate-active-border);background:#fff;box-shadow:0 1px 2px #00000052;font-family:var(--typography-opensans-body-body1-font-family);font-size:var(--typography-opensans-body1-font-size);overflow-x:auto}.sol-select .cdk-overlay-pane{width:100%}.sol-select .dropdown-category{padding:.5rem .625rem;font-size:.8125rem;font-weight:700}.sol-select .search-inner{display:flex;flex-direction:row;height:2.25rem;align-items:center;gap:.5rem;padding:0 .25rem 0 .625rem}.sol-select .search-inner .search-icon-container{display:flex;flex-direction:column;justify-content:center;height:1.25rem;width:1.25rem}.sol-select .search-inner .search-input-box{flex-grow:1;height:1.125rem;appearance:none;border:none;outline:none;padding:0}.sol-select .search-inner .search-input-box::placeholder{color:var(--color-globalstate-inactive-icon);font-size:.8125rem}.sol-select .search-inner .search-clear-btn{height:1.75rem;width:1.75rem}.sol-select .no-results-container{height:1.25rem;margin:0;padding:.5rem .625rem;font-family:var(--typography-opensans-body-body3-font-family);font-size:.8125rem;font-style:normal;font-weight:400;line-height:.975rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-select .select-all-checkbox-container{height:2.65rem;display:flex;flex-direction:column;justify-content:flex-start;background:var(--interface-background-50, #f5f8fa)}.sol-select .select-all-checkbox-container .sol-option{background:var(--interface-background-50, #f5f8fa)}.sol-select .select-all-checkbox-container:hover,.sol-select .select-all-checkbox-container:hover .sol-option{background:var(--color-globalstate-hover-background)}.sol-select .select-all-checkbox-container .divider{border-width:0 0 .0625rem;border-style:solid;border-color:#ebebeb;margin:0 .25rem}.sol-select .max-selection-limit-container{box-sizing:border-box;border:1px solid var(--color-interface-border2);border-left-width:0;border-right-width:0;height:2.25rem;display:flex;flex-direction:column;justify-content:center;padding:0 .625rem;background-color:var(--color-surface-secondary)}.sol-select .max-selection-limit-container .max-selection-limit-row{display:flex;flex-direction:row;justify-content:space-between}.sol-select .max-selection-limit-container .max-selection-limit-row .max-selection-limit-text{text-transform:var(--typography-opensans-body-body3-text-case);text-indent:var(--typography-opensans-body-body3-paragraph-indent);line-height:var(--typography-opensans-body-body3-line-height);letter-spacing:var(--typography-opensans-body-body3-letter-spacing);font-stretch:var(--typography-opensans-body-body3-font-stretch);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-family:var(--typography-opensans-body-body3-font-family);text-decoration:var(--typography-opensans-body-body3-text-decoration);font-size:var(--typography-opensans-body-body3-font-size);width:100%;align-self:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sol-select .max-selection-limit-container .max-selection-limit-row .max-selection-limit-clear-button{align-self:center}.sol-select .max-selection-limit-container .max-selection-limit-row button div{min-width:4rem}.sol-select .clear-search-icon{height:1.75rem;width:1.75rem;background:url('data:image/svg+xml,<svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A    <path%0A        d=\"M11.0938 10.3245L14.7656 6.68112C15.0781 6.37104 15.0781 5.90592 14.7656 5.59584C14.4531 5.28577 13.9844 5.28577 13.6719 5.59584L10 9.23926L6.32812 5.51832C6.01562 5.20825 5.54688 5.20825 5.23438 5.51832C4.92188 5.8284 4.92188 6.29352 5.23438 6.6036L8.90625 10.3245L5.23438 13.9679C4.92188 14.278 4.92188 14.7431 5.23438 15.0532C5.54688 15.3633 6.01562 15.3633 6.32812 15.0532L10 11.4098L13.6719 15.0532C13.9844 15.3633 14.4531 15.3633 14.7656 15.0532C15.0781 14.7431 15.0781 14.278 14.7656 13.9679L11.0938 10.3245Z\"%0A        fill=\"%233F5C69\" />%0A</svg>%0A');background-position:center;background-repeat:no-repeat;background-size:inherit;border:0}.sol-select .sol-options-list{list-style-type:none;min-width:15rem;max-height:13.5rem;overflow:auto;margin:0;padding:0}.sol-select *{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}.sol-select *::-webkit-scrollbar{width:8px}.sol-select *::-webkit-scrollbar-corner{display:none}.sol-select *::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}.sol-select *::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}.sol-select *::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}.sol-select * ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    maxSelectionLimit: [{
      type: Input
    }],
    searchEnabled: [{
      type: Input
    }],
    searchFunction: [{
      type: Input
    }],
    isMultiple: [{
      type: Input
    }],
    optionsLabel: [{
      type: Input
    }],
    optionsValue: [{
      type: Input
    }],
    optionsIcon: [{
      type: Input
    }],
    isReadOnly: [{
      type: Input
    }],
    projectedContent: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    selection: [{
      type: Input
    }],
    selectionChange: [{
      type: Output
    }],
    searchChanged: [{
      type: Output
    }]
  });
})();
const components = [OptionComponent, SelectComponent];
class SelectModule {
  static {
    this.ɵfac = function SelectModule_Factory(t) {
      return new (t || SelectModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SelectModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AutoCompleteModule, CommonModule, ButtonModule, CheckboxModule, IconModule, TextInputModule, TranslationModule, OverlayModule, PortalModule, A11yModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectModule, [{
    type: NgModule,
    args: [{
      declarations: components,
      imports: [AutoCompleteModule, CommonModule, ButtonModule, CheckboxModule, IconModule, TextInputModule, TranslationModule, OverlayModule, PortalModule, A11yModule],
      exports: components
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OptionComponent, SelectComponent, SelectModule };
